export default __webpack_public_path__ + "static/media/favicon.eb684c0e.ico";